/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ minValue: NonNullable<unknown>, maxValue: NonNullable<unknown> }} Wise_Cool_Dolphin_SwimInputs */

const en_wise_cool_dolphin_swim = /** @type {(inputs: Wise_Cool_Dolphin_SwimInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`From ${i?.minValue} to ${i?.maxValue}`)
};

const de_wise_cool_dolphin_swim = /** @type {(inputs: Wise_Cool_Dolphin_SwimInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Von ${i?.minValue} bis ${i?.maxValue}`)
};

/**
* | output |
* | --- |
* | "From {minValue} to {maxValue}" |
*
* @param {Wise_Cool_Dolphin_SwimInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const wise_cool_dolphin_swim = /** @type {((inputs: Wise_Cool_Dolphin_SwimInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wise_Cool_Dolphin_SwimInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_wise_cool_dolphin_swim(inputs)
	return de_wise_cool_dolphin_swim(inputs)
});